import * as React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { useConfigService } from '@thd-nucleus/experience-context';
import { getImageURL } from '../../../utils/GeneralUtil';
import { InfoPerksContext } from '../../../contexts';
import './ProXtraPerkBanner.scss';
import { PageSectionPB } from '../../PricingBenefits/shared';
import { pkPerkBanner } from '../../../constants/ProXtraPerks';
var BackGroundBuild = function (style1) {
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true },
            React.createElement("img", { src: getImageURL('dt-perks-banner.jpg'), className: style1, alt: "Top banner, Home Depot store", width: "100%", height: "auto" }))));
};
var MobilePerkBackBuild = function () {
    return (React.createElement(Grid, { container: true },
        React.createElement("img", { src: getImageURL('banner-Perks-mobile.jpg'), alt: "Top banner, Home Depot store", width: "100%", height: "auto" })));
};
var TextLoader = function (props) {
    var style1 = props.style1, style2 = props.style2;
    return (React.createElement(Grid, { item: true },
        React.createElement(Grid, { container: true }, pkPerkBanner.bannerData.map(function (info) { return (React.createElement(Grid, { item: true, md: 4, lg: 4, xl: 4, key: info.heading },
            React.createElement("h1", { className: style1 }, info.heading),
            React.createElement("h2", { className: style2 }, info.description))); }))));
};
var TextLoaderTablet = function (props) {
    var style1 = props.style1, style3 = props.style3;
    return (React.createElement(Grid, { item: true },
        React.createElement("h1", { className: style3 }, "Earning Perks is simple."),
        React.createElement(Grid, { container: true }, pkPerkBanner.bannerData.map(function (info) { return (React.createElement(Grid, { item: true, sm: 4, md: 4, lg: 4, xl: 4, key: info.heading },
            React.createElement("h1", { className: style1 },
                info.heading,
                "."))); }))));
};
var MobileTextPerkLoader = function () {
    return (React.createElement(Grid, { item: true, className: "bannerPerkTextMobileContainer" },
        React.createElement("h1", { className: "bannerPerkTextMobile" }, pkPerkBanner.bannerData.map(function (info) { return (React.createElement(Grid, { item: true, key: info.heading, className: "bannerPerkTextMobileSection" },
            React.createElement("h1", null,
                info.heading,
                "."))); })),
        React.createElement("h2", { className: "bannerPerkTextMobile2" }, pkPerkBanner.bannerPerkTextMobile2)));
};
var BannerPerkContent = function () {
    return (React.createElement(Grid, { item: true, className: "rightSidePerk" },
        React.createElement(Hidden, { lgDown: true },
            React.createElement(TextLoader, { style1: "bannerPerkText", style2: "bannerPerkText2" })),
        React.createElement(Hidden, { xlUp: true },
            React.createElement(TextLoaderTablet, { style1: "bannerTextPerkTablet", style3: "bannerTextPerkTablet3" }))));
};
var MobileBannerContent = function () {
    return (React.createElement(Grid, { container: true, direction: "column" },
        React.createElement(MobilePerkBackBuild, null),
        React.createElement(MobileTextPerkLoader, null)));
};
var DesktopPerkBanner = function () {
    return (React.createElement(Grid, { container: true, className: "bannerPerk", direction: "column" },
        React.createElement(Grid, { item: true },
            React.createElement(Hidden, { lgDown: true },
                React.createElement(BackGroundBuild, { style1: "perkBannerDesktop" }),
                React.createElement(BannerPerkContent, null)),
            React.createElement(Hidden, { xlUp: true },
                React.createElement(BackGroundBuild, { style1: "perkBannerTabletDesktop" }),
                React.createElement(BannerPerkContent, null)))));
};
var MobilePerkBanner = function () {
    return (React.createElement(Grid, { container: true, className: "bannerPerkMobile", direction: "row" },
        React.createElement(MobileBannerContent, null)));
};
var DesktopRecentActiveBanner = function () { return (React.createElement(Grid, { container: true },
    React.createElement(Grid, { item: true, className: "perk-banner__perkBannerDTM" },
        React.createElement("img", { src: getImageURL('dt-perks-banner.jpg'), className: "perk-banner__perkBannerDesktop", alt: "Top banner, Home Depot store", width: "100%", height: "auto" })))); };
var DesktopRecentActiveTabletBanner = function () { return (React.createElement(Grid, { container: true },
    React.createElement(Grid, { item: true, className: "perk-banner__perkBannerDTM" },
        React.createElement("img", { src: getImageURL('dt-perks-banner.jpg'), className: "perk-banner__perkBannerDesktop", alt: "Top banner, Home Depot store", width: "100%", height: "auto" })))); };
var MobileRecentActiveBanner = function () { return (React.createElement(Grid, { container: true },
    React.createElement("img", { src: getImageURL('banner-bg-PLCC-NotEnrolled.svg'), className: "perkBannerMobileRecentActive", alt: "Top banner, Home Depot store", width: "100%", height: "auto" }))); };
var RecentActiveBannerDt = function () { return (React.createElement(Grid, { item: true },
    React.createElement(Hidden, { lgDown: true },
        ' ',
        React.createElement(DesktopRecentActiveBanner, null)),
    React.createElement(Hidden, { xlUp: true },
        ' ',
        React.createElement(DesktopRecentActiveTabletBanner, null)))); };
var BannerRecentActivePerkContent = function () {
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    return (React.createElement(Grid, { container: true, direction: "row", className: "perk-banner__recentActiveBox" },
        React.createElement(Grid, { item: true, sm: 8, md: 8, lg: 9, xl: 8 },
            React.createElement("h1", { className: "perk-banner__recentActiveHeading" },
                React.createElement("b", null, pkPerkBanner.recentActiveHeading)),
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(Hidden, { smDown: true },
                        React.createElement("h2", { className: "perk-banner__rcDesktoptext" }, isHDPassVerbageEnabled
                            ? pkPerkBanner.recentActiveTextHDPass
                            : pkPerkBanner.recentActiveText)),
                    React.createElement(Hidden, { mdUp: true },
                        React.createElement("h2", { className: "perk-banner__rcDesktoptext" }, isHDPassVerbageEnabled
                            ? pkPerkBanner.recentActiveMobileTextHDPass
                            : pkPerkBanner.recentActiveMobileText)))))));
};
var BannerRecentActivePerkMobileContent = function () {
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    return (React.createElement(Grid, { container: true, className: "perk-banner__recentActiveBox" },
        React.createElement(Grid, { item: true },
            React.createElement("h2", { className: "perk-banner__rcMobileText" }, isHDPassVerbageEnabled
                ? pkPerkBanner.recentActiveMobileTextHDPass
                : pkPerkBanner.recentActiveMobileText))));
};
var DesktopTextPerkLoader = function () {
    var _a, _b;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var previousYearForBannerDisplay = ((_b = (_a = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.year) - 1 || '';
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, className: "perk-banner__preYearText" },
            React.createElement(Grid, { item: true, className: "perk-banner__preYearTextContainer" },
                React.createElement("h1", { className: "perk-banner__preYearDesktop" },
                    ' ',
                    pkPerkBanner.previousYearForBannerDisplay1,
                    ' ',
                    previousYearForBannerDisplay,
                    ".",
                    ' '),
                React.createElement("h2", { className: "perk-banner__preYearSubTitleDesktop" }, pkPerkBanner.previousYearForBannerDisplay2)),
            React.createElement(Grid, { item: true, className: "perk-banner__yearDesktopContainer" },
                ' ',
                React.createElement("h2", { className: "perk-banner__yearDesktop" }, previousYearForBannerDisplay)))));
};
var MobilePreYearBackBanner = function () { return (React.createElement(Grid, { container: true, className: "perk-banner__perkPreBannerMobileContainer" },
    React.createElement("img", { src: getImageURL('banner-Perks-Annualization-mobile.jpg'), className: "perk-banner__perkPreBannerMobile", alt: "Top banner, Home Depot store", width: "100%", height: "auto" }))); };
var DesktopPrevYearBanner = function () { return (React.createElement(Grid, { container: true },
    React.createElement(Grid, { item: true, className: "perk-banner__perkBannerDTM" },
        React.createElement("img", { src: getImageURL('dt-annualization-banner.jpg'), className: "perk-banner__perkBannerDesktop", alt: "Top banner, Home Depot store", width: "100%", height: "auto" })))); };
var DesktopPreYear = function () { return (React.createElement(Grid, { container: true, direction: "column" },
    React.createElement(DesktopPrevYearBanner, null),
    React.createElement(DesktopTextPerkLoader, null))); };
var MobilePreYear = function () { return (React.createElement(Grid, { className: "bannerPerkMobile", container: true },
    React.createElement(MobilePreYearBackBanner, null),
    React.createElement(DesktopTextPerkLoader, null))); };
var RecentActiveBanner = function (_a) {
    var isMobile = _a.isMobile;
    return (React.createElement(Grid, { item: true },
        React.createElement(Grid, { item: true, className: "perk-banner__recentActiveBannerBox" }, isMobile ? (React.createElement(Grid, { className: "bannerPerkMobile", container: true },
            React.createElement(MobileRecentActiveBanner, null),
            React.createElement(BannerRecentActivePerkMobileContent, null))) : (React.createElement(React.Fragment, null,
            React.createElement(RecentActiveBannerDt, null),
            React.createElement(BannerRecentActivePerkContent, null))))));
};
var PerkProgressElement = function (_a) {
    var isMobile = _a.isMobile;
    return (React.createElement(Grid, null, isMobile ? React.createElement(MobilePerkBanner, null) : React.createElement(DesktopPerkBanner, null)));
};
var PrevYearBanner = function (_a) {
    var isMobile = _a.isMobile;
    return (React.createElement(Grid, { item: true },
        React.createElement(Grid, { item: true, className: "bannerPerk" }, isMobile ? React.createElement(MobilePreYear, null) : React.createElement(DesktopPreYear, null))));
};
export var ProXtraPerkBanner = function (ProXtraPerkBannerProps) {
    var _a;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var isMobile = ProXtraPerkBannerProps.isMobile;
    var perksRecentlyAdded = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.recentlyAdded;
    var previousYearForBannerDisplay = (_a = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.previousYearPerks) === null || _a === void 0 ? void 0 : _a.some(function (perk) { return perk.perkStatus === 'UNCLAIMED'; });
    var banner;
    if (previousYearForBannerDisplay) {
        banner = React.createElement(PrevYearBanner, { isMobile: isMobile });
    }
    else {
        banner = perksRecentlyAdded ? (React.createElement(RecentActiveBanner, { isMobile: isMobile })) : (React.createElement(PerkProgressElement, { isMobile: isMobile }));
    }
    return (React.createElement(React.Fragment, null, isMobile ? (React.createElement(Grid, null, banner)) : (React.createElement(Grid, { className: "bannerPerkDesktop" },
        React.createElement(PageSectionPB, { title: "Pro Xtra Perks" },
            React.createElement(Grid, null, banner))))));
};
